import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import type { UserOrganisation } from '../types/types';
import DashboardComponent from '../components/common/DashboardComponent';
import SupplierDashboard from '../components/supplier/SupplierDashboard';

const Dashboard = () => {
  const selectedOrganisation = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.organisation.selected,
  ) as UserOrganisation | undefined;

  if (!selectedOrganisation) {
    return null;
  }

  return (
    <Container fluid>
      {selectedOrganisation?.role === 'supplier' ? (
        <SupplierDashboard />
      ) : (
        <DashboardComponent />
      )}
    </Container>
  );
};

export default Dashboard;
